import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";

import { Stack, Box } from "@mui/material";
import { FETCH_JOB } from "../../api/jobs";
import FeedItem from "./FeedItem";
import LoadingScreen from "../../components/LoadingScreen";
import SoftTypography from "../../components/SoftTypography";
import SoftBox from "../../components/SoftBox";
import PageHeader from "../../components/PageHeader";

const SingleFeed = () => {
  const { jobId } = useParams();
  // A notification click (e.g. "commented on your job post") lands here with
  // this set, so the comment thread that prompted the notification is
  // already open instead of making the user find and click it themselves.
  const { state } = useLocation();
  const openComments = !!state?.openComments;
  const [isLoading, setIsLoading] = useState(true);
  const [job, setJob] = useState({});

  const fetchJob = async () => {
    const data = await FETCH_JOB(jobId);
    setJob(data.data);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchJob();
  }, []);

  return (
    <div>
      <div className="container my-10 mt-5">
        <PageHeader
          headerText="Single Feed"
          subheaderText="View detailed information about this specific team member's job feed."
        />
        <SoftBox sx={{ margin: { mini: "1rem", sm: "1.5rem" } }}>
          <div className="feedContainer flex justify-center">
            {isLoading ? (
              <LoadingScreen />
            ) : (
              <Stack className="flex items-center">
                <FeedItem job={job} openComments={openComments} />
              </Stack>
            )}
          </div>
        </SoftBox>
      </div>
    </div>
  );
};

export default SingleFeed;
